<template>
  <v-app id="inspire">
    <div class="row">
    <div class="text-center">
    <v-overlay 
        :value="overlay"
        :opacity=0.1
    >
      
    </v-overlay>
  </div>
  <v-card
    class="mx-auto col-md-8 mb-12 mt-12"
    style=" z-index:8; padding:10px;"
    center
  >
    <v-card-text class="mb-12">
      <!-- <div>Word of the Day</div> -->
      <div class="row">
        
<!-- drawer here -->
    <!-- header here -->
    <v-content >
      <v-container
        fluid
        class="topstyle"
      >
        
          <!-- contents here -->
            <div class="row">
                <top-cards />
                <div clses="clearfix"></div>
            </div>
            <div class="row">
                <members class="col-md-12 mb-4" />
                <v-spacer></v-spacer>
                <br><br>
                <tasks class="col-md-12 mb-3"></tasks>
                <div clses="clearfix"></div>
            </div>
          <!-- /contents here -->
          
      </v-container>
    </v-content>
    
    <!-- dialog here for adding new circle -->
    <new-circle-dialog
        :dialogactive="dialog"
    ></new-circle-dialog>


      </div>
    </v-card-text>
  </v-card>
  </div>
  <v-btn
      bottom
      color="pink"
      dark
      fab
      fixed
      style="z-index:10;"
      right
      @click="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>
  <bottom-nav style="z-index:9"></bottom-nav>
  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      overlay: false,
      dialog: false,
    //   topstyle:"margin-left: -250px; margin-top: -50px;"
    }),
    watch: {
        
    },
  }
</script>

<style scoped>

@media screen and (min-width: 700px) {
        .topstyle {
            margin-left: 100px; 
            padding-right: 200px; 
            margin-top: -50px;
        }
    }

@media screen and (max-width: 700px) {
        .topstyle {
            margin-left: 50px; 
            padding-right: 100px; 
            margin-top: -50px;
        }
    }
</style>